<template>
  <app-toast class='risk-result' :message='message'>
    <div class='toast-body' v-html='$t("toasts.password-updated")'>
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'password-updated',

    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
</style>
